import { useState } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Checkbox } from '@wartek-id/checkbox-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

interface DialogConfirmSaveEditProps extends Omit<DialogProps, 'children'> {
  onConfirm?: () => Promise<void>
}

export default function DialogConfirmSaveEdit({
  onConfirm = async () => {},
  ...props
}: DialogConfirmSaveEditProps) {
  const [isConfirmEditRHK, setIsConfirmEditRHK] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <Dialog {...props}>
      <DialogOverlay />

      <DialogContent>
        <div className="px-6 py-8 flex flex-col gap-4">
          <Text variant="display-sm">
            Rencana Hasil Kerja yang lama akan dihapus. Lanjut simpan Rencana
            Hasil Kerja yang baru?
          </Text>

          <Text variant="body-lg" color="subdued" className="!text-[20px]">
            Setelah disimpan, Anda akan melaksanakan rencana yang baru. Anda
            juga dapat mengubah rencana jika perlu.
          </Text>

          <Checkbox
            checked={isConfirmEditRHK}
            onChange={(e) => setIsConfirmEditRHK(e.target.checked)}
          >
            Saya menyatakan bahwa Rencana Hasil Kerja sudah sesuai dan sudah
            didiskusikan dengan atasan.
          </Checkbox>

          <div className="flex gap-5">
            <Button size="lg" color="white" onClick={() => props.onClose?.()}>
              Kembali
            </Button>
            <Button
              size="lg"
              disabled={!isConfirmEditRHK || isLoading}
              isLoading={isLoading}
              onClick={async () => {
                setIsLoading(true)
                try {
                  await onConfirm()
                } finally {
                  setIsLoading(false)
                  props.onClose?.()
                }
              }}
            >
              Simpan
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
